"use client";

import { AccordionItem } from "@JohnLewisPartnership/jl-design-system/dist/components/accordion/accordion-item/AccordionItem";
import styles from "./HowToUseAccordion.module.scss";
import { cleanHtml } from "../../../../utils/string/cleanHtml";
import { useState } from "react";
import { ProductAccordionWithMonetateEvents } from "../../ProductAccordionWithMonetateEvents";
type Props = {
  open?: boolean;
  howtoUseContent: string | null | undefined;
};

export const PRODUCT_HOW_TO_USE_ACCORDION_INSTANCE_NAME = "how-to-use";

export function ProductHowToUseAccordionUI({ open, howtoUseContent }: Props) {
  const [isOpen, setIsOpen] = useState(open);
  if (!howtoUseContent) {
    return null;
  }

  return (
    <ProductAccordionWithMonetateEvents name="How To Use" open={isOpen}>
      <AccordionItem
        id="accordion-how-to-use"
        className={styles["product-accordion__item"]}
        data-testid="accordion:how-to-use"
        header={<div className={styles.accordionTitle}>How to use</div>}
        instanceName={PRODUCT_HOW_TO_USE_ACCORDION_INSTANCE_NAME}
        isOpen={open}
        onStateChange={(isOpen: boolean) => {
          setIsOpen(isOpen);
        }}
      >
        <div
          data-testid="howToUse:Description"
          className={styles.productDescriptionBody}
          dangerouslySetInnerHTML={{ __html: cleanHtml(howtoUseContent) || "" }}
        />
      </AccordionItem>
    </ProductAccordionWithMonetateEvents>
  );
}
